import semver from "semver";
import { fetchMinVersion } from "@ano/shared/api/min-version";

export interface MinVersionViolation {
  platform: "desktop";
  currentVersion: string;
  minVersion: string;
  message?: string;
}

export interface MinVersionCheckInput {
  apiBaseUrl: string;
  currentVersion: string;
}

/**
 * Fetches /api/min-version and compares against the current desktop version.
 * Fails open on any error (network, 5xx, malformed response) so a server outage
 * never blocks users. Only an explicit below-min response returns a violation.
 */
export async function checkMinVersion({
  apiBaseUrl,
  currentVersion,
}: MinVersionCheckInput): Promise<MinVersionViolation | null> {
  try {
    const response = await fetchMinVersion({ apiBaseUrl });
    const min = response.minDesktopVersion;
    if (!semver.valid(min) || !semver.valid(currentVersion)) {
      return null;
    }
    if (semver.lt(currentVersion, min)) {
      return {
        platform: "desktop",
        currentVersion,
        minVersion: min,
        message: response.message,
      };
    }
    return null;
  } catch (error) {
    console.warn("[min-version] check failed — failing open", error);
    return null;
  }
}
